import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import {
  DialogService,
  DynamicDialogRef,
  DynamicDialogModule,
  DynamicDialogConfig,
} from 'primeng/dynamicdialog';
import { AddVehicleFormComponent } from '../../dialogs/add-vehicle-form/add-vehicle-form.component';

import { ButtonModule } from 'primeng/button';
import { ToolbarModule } from 'primeng/toolbar';
import { InputTextModule } from 'primeng/inputtext';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SidebarModule } from 'primeng/sidebar';
import { RippleModule } from 'primeng/ripple';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from '../../../core/state/app.state';
import { LoginDialogComponent } from '../../dialogs/auth/login-dialog/login-dialog.component';
import { SearchInputComponent } from '../form/search-input/search-input.component';
import { UserInnerMenuComponent } from '../user-inner-menu/user-inner-menu.component';
import { Platform } from '@angular/cdk/platform';
import { Observable, combineLatest, Subject, of } from 'rxjs';
import {
  BootstrapGridBreakpoints,
  BreakpointsService,
} from '../../services/breakpoints.service';
import { AddVehicleButtonBlockComponent } from './add-vehicle-button-block/add-vehicle-button-block.component';
import { MobileAddVehicleButtonBlockComponent } from './mobile-add-vehicle-button-block/mobile-add-vehicle-button-block.component';
import { IShopParams } from '../../../routes/shop/shop.component';
import { SidenavCartInnerComponent } from './../sidenav-cart-inner/sidenav-cart-inner.component';
import { StateService } from '../../../core/state/old/state.service';
import { DataService } from '../../../core/providers/data/data.service';
import {
  Customer,
  GetActiveCustomerQuery,
  Order,
  Query,
  SavedVehicle,
} from '../../../graphql/generated/generated-types';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ActiveService } from '../../../core/providers/active/active.service';
import { CartPriceAndActionsBlockComponent } from '../sidenav-cart-inner/cart-price-and-actions-block/cart-price-and-actions-block.component';
import { FormatPricePipe } from '../../pipes/format-price.pipe';

import { map, skip, take, takeUntil, tap } from 'rxjs/operators';
import { NotAvailableOverlayComponent } from '../not-available-overlay/not-available-overlay.component';
import { GET_CUSTOMER_NAMES } from './active-customer.graphql';
import { environment } from '../../../../environments/environment';
import { SavedItemsService } from '../../services/saved-items.service';
import { VehicleTypeGlobalSelectionBlockComponent } from './vehicle-type-global-selection-block/vehicle-type-global-selection-block.component';
import { VehicleTypeGlobalSelectionListComponent } from './vehicle-type-global-selection-list/vehicle-type-global-selection-list.component';
import { reloadCurrentComponent } from '../../utils/reload-current-navigation';
import { VehicleTypeService } from '../../services/vehicle-type.service';
import { SelectedModificationService } from '../../services/selected-modification.service';

export interface ICartTotals {
  total: number;
  subTotal: number;
  quantity: number;
}
@Component({
  selector: 'app-navigation',
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
    FormsModule,
    ReactiveFormsModule,
    ToolbarModule,
    InputTextModule,
    SidebarModule,
    RippleModule,
    DynamicDialogModule,
    AddVehicleFormComponent,
    RouterLink,
    SearchInputComponent,
    UserInnerMenuComponent,
    LoginDialogComponent,
    AddVehicleButtonBlockComponent,
    MobileAddVehicleButtonBlockComponent,
    SidenavCartInnerComponent,
    ProgressSpinnerModule,
    CartPriceAndActionsBlockComponent,
    FormatPricePipe,
    NotAvailableOverlayComponent,
    VehicleTypeGlobalSelectionBlockComponent,
    VehicleTypeGlobalSelectionListComponent,
  ],
  providers: [DialogService, DynamicDialogRef, DynamicDialogConfig],
  templateUrl: './navigation.component.html',
  styleUrl: './navigation.component.scss',
})
export class NavigationComponent implements OnInit, OnDestroy {
  public searchControl: FormControl = new FormControl('');
  public mobileSearchEnabled: boolean = false;
  private previousScroll = 0;
  public navHidden = false;
  public navbarOpen = false;
  public stickyNav = false;
  isSignedIn$: Observable<boolean>;

  @HostListener('window:scroll', [])
  onScroll() {
    const scrollThreshold = 50;
    if (typeof window !== 'undefined') {
      if (this.previousScroll > window.scrollY && window.scrollY <= 200) {
        // Restore nav when within 200 pixels from the top
        this.navHidden = false;
        this.stickyNav = false;
      } else if (this.previousScroll < window.scrollY) {
        // Scrolling down
        if (window.scrollY > 100) {
          this.navHidden = true;
          this.stickyNav = !this.navbarOpen;
        }
      } else if (this.previousScroll - window.scrollY > scrollThreshold) {
        // Scrolling up with a threshold
        this.stickyNav = true;
        this.navHidden = false;
      }
    }
    this.previousScroll = window.scrollY;
  }

  @HostListener('document:keydown.enter', ['$event']) onKeydownHandler(
    event: KeyboardEvent
  ) {
    if (this.searchControl.value && this.searchControl.value !== '') {
      this.searchProducts(this.searchControl.value);
    }
  }

  public userMobileMenuVisible: boolean;
  public cartSidebarVisible: boolean;
  public mobileMenuIsOpened: boolean;
  public addVehicleBottomSheetOpened: boolean;

  public globalSidebarMenuVisible: boolean;
  public globalSidebarMenuVisible$: Observable<boolean>;

  public userMobileMenuVisible$: Observable<boolean>;
  public cartSidebarVisible$: Observable<boolean>;
  public mobileMenuIsOpened$: Observable<boolean>;
  public addVehicleBottomSheetOpened$: Observable<boolean>;

  public lgLayout: boolean = true;
  public mdLayout: boolean = false;
  public smLayout: boolean = false;

  activeOrder$: Observable<Order>;
  public activeOrderloading$: Observable<boolean>;
  private unsubscribe$ = new Subject<void>();

  activeCustomer$: Observable<Customer>;
  activeVehicle$: Observable<SavedVehicle | null>;
  public activeVehicle: SavedVehicle | null;
  public enableSavedItems: boolean = environment.websiteSettings.enableSavedItems;


  private isInit = true; // Track first-time initialization
  public vehicleTypeRouteParam: string | null = null;
  public modificationRouteParam: string | null = null;

  constructor(
    private store: Store<AppState>,
    public dialogService: DialogService,
    private platform: Platform,
    private breakpointsService: BreakpointsService,
    private route: ActivatedRoute,
    private router: Router,
    private stateService: StateService,
    private dataService: DataService,
    private activeService: ActiveService,
    public savedItemsService: SavedItemsService,
    private locationService: Location,
    public vehicleTypeService: VehicleTypeService,
    public selectedModificationService: SelectedModificationService
  ) {}

  ngOnInit(): void {
    this.userMobileMenuVisible$ = this.stateService.select(
      (state) => state.userMobileMenuVisible
    );

    this.globalSidebarMenuVisible$ = this.stateService.select(
      (state) => state.globalSidebarMenuVisible
    );

    this.cartSidebarVisible$ = this.stateService.select(
      (state) => state.cartSidebarVisible
    );
    this.mobileMenuIsOpened$ = this.stateService.select(
      (state) => state.mobileMenuIsOpened
    );
    this.addVehicleBottomSheetOpened$ = this.stateService.select(
      (state) => state.addVehicleBottomSheetOpened
    );

    // this should go first because it has if !isInit
    this.subscribeToAddVehicleBottomSheetDrawerOpened();
    // comment end
    
    this.subscribeToAllDrawers();
    if (this.platform.isBrowser) {
      combineLatest([
        this.breakpointsService.isBreakpointOrLower(
          BootstrapGridBreakpoints.LGLabel
        ),
        this.breakpointsService.isBreakpointOrLower(
          BootstrapGridBreakpoints.MDlabel
        ),
        this.breakpointsService.isBreakpointOrLower(
          BootstrapGridBreakpoints.SMlabel
        ),
      ])
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(([lgMatches, mdMatches, smMatches]) => {
          this.lgLayout = lgMatches;
          this.mdLayout = mdMatches;
          this.smLayout = smMatches;
        });

      this.subscribeToActiveOrder();
      this.getActiveCustomer();
      this.subscribeToActiveVehicle();
    }
  }

  private getActiveCustomer() {
    this.activeCustomer$ = this.activeService.activeCustomer$.pipe(
      takeUntil(this.unsubscribe$)
    );
  }

  private subscribeToActiveVehicle() {

    this.activeVehicle$ = this.activeService.activeVehicle$?.pipe(
      takeUntil(this.unsubscribe$)
    );

    this.activeVehicle$?.subscribe({
      next : (response: SavedVehicle | null) => {
        console.log('NAVIGATION ACTIVE VEHICLE RESPONSE', response);
        if(response){
          this.activeVehicle = response;
        } else {
          this.activeVehicle = null;
        }
      }
    })
  

}

  private fetchActiveCustomer(): Observable<Customer> {
    return this.dataService
      .query<GetActiveCustomerQuery>(GET_CUSTOMER_NAMES, {}, 'network-only')
      .pipe(
        map((data) => data.activeCustomer as Customer),
        takeUntil(this.unsubscribe$)
      );
  }
  private subscribeToAddVehicleBottomSheetDrawerOpened() {
    this.addVehicleBottomSheetOpened$
      .pipe(skip(1),takeUntil(this.unsubscribe$))
      .subscribe((response) => {
        console.warn('RESPONSE', response);
   
          if (!response) {
            this.vehicleSelected(true);
          }
        
      });
  }

  subscribeToAllDrawers() {
    combineLatest([
      this.userMobileMenuVisible$,
      this.cartSidebarVisible$,
      this.mobileMenuIsOpened$,
      this.addVehicleBottomSheetOpened$,
      this.globalSidebarMenuVisible$,
    ])
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        ([
          userMobileMenuVisible,
          cartSidebarVisible,
          mobileMenuIsOpened,
          addVehicleBottomSheetOpened,
          globalSidebarMenuVisible,
        ]) => {
          this.userMobileMenuVisible = userMobileMenuVisible;
          this.cartSidebarVisible = cartSidebarVisible;
          this.mobileMenuIsOpened = mobileMenuIsOpened;
          this.addVehicleBottomSheetOpened = addVehicleBottomSheetOpened;
          this.globalSidebarMenuVisible = globalSidebarMenuVisible;
        }
      );
  }

  public subscribeToActiveOrder() {
    this.activeOrder$ = this.activeService.activeOrder$.pipe(
      takeUntil(this.unsubscribe$)
    );
  }

  public searchProducts(searchTerm: string) {
    this.router.navigate(['/'+this.vehicleTypeService.currentVehicleType + '/shop/search'], {
      queryParams: { search: searchTerm, modificationId: this.selectedModificationService.selectedModificationId } as IShopParams,
      relativeTo: this.route,
    });
    this.searchControl.setValue('', { emitEvent: false });
  }

  public goToUserPage() {
    this.router.navigate(['/user/account'], {
      queryParams: { modificationId: this.selectedModificationService?.selectedModificationId }
    });
  }

  public openLoginDialog() {
    const dialogRef: DynamicDialogRef = this.dialogService.open(
      LoginDialogComponent,
      {
        styleClass: 'auth-custom-dialog',
        modal: true,
        showHeader: false,
        closeOnEscape: true,
        dismissableMask: true,
      }
    );

    dialogRef.onClose.subscribe((result) => {
      if(result){
                 /*
        this.router.navigate(['/'], { queryParamsHandling: 'merge', skipLocationChange: true }).then(() => {
          this.router.navigate(['/' + (this.vehicleTypeService.currentVehicleType)], {
            queryParamsHandling: 'merge'
          });
        })
           */
      }
    });
  }

  public showAddVehicleBottomSheet() {
    this.openAddVehicleBottomSheet();
    this.addVehicleBottomSheetOpened = true;
  }

  public vehicleSelected(selected: boolean) {
    console.log('VEHICLE SELECTED SERVICE');
 
    if(this.activeService.activeVehicle$){
    // if(selected){ right now always reload current comp after manage vehicle popup closes (Because when changing TYPES 
    // vehicle is not selected, but reload is needed)
    this.activeService.activeVehicle$.pipe(take(1)).subscribe({
      complete: () => {
        console.log('shoud reload', this.isInit)
     // if (!this.isInit) {
        console.log('reload incoming')
        reloadCurrentComponent(this.router, this.stateService, this.locationService);
     // }
      this.isInit = false; // Set false after first execution
      },
    });
    // } else {

    //  }
    }
  }



  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  openGlobalSidebarMenu() {
    this.stateService.setState('globalSidebarMenuVisible', true);
  }

  closeGlobalSidebarMenu() {
    this.stateService.setState('globalSidebarMenuVisible', false);
  }

  openCartSidebar() {
    this.stateService.setState('cartSidebarVisible', true);
  }

  closeCartSidebar() {
    this.stateService.setState('cartSidebarVisible', false);
  }

  openUserMobileMenu() {
    this.stateService.setState('userMobileMenuVisible', true);
  }

  closeUserMobileMenu() {
    this.stateService.setState('userMobileMenuVisible', false);
  }

  openAddVehicleBottomSheet() {
    this.stateService.setState('addVehicleBottomSheetOpened', true);
  }

  closeAddVehicleBottomSheet() {
    this.stateService.setState('addVehicleBottomSheetOpened', false);
  }

  openMobileMenu() {
    this.stateService.setState('mobileMenuIsOpened', true);
  }

  closeMobileMenu() {
    this.stateService.setState('mobileMenuIsOpened', false);
  }
}
